// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grok-style scrollbar - Global styles */

/* Webkit browsers (Chrome, Safari, Edge) */
*::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  transition: background 0.2s ease;
}

*::-webkit-scrollbar-thumb:hover {
  background: rgba(237, 137, 54, 0.6); /* Orange on hover */
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
}

/* Smooth scrolling for all scrollable elements */
* {
  scroll-behavior: smooth;
}

/* Premium button animations */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/scrollbar.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC,2CAA2C;AAC3C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC,EAAE,oBAAoB;AAC3D;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,iDAAiD;AACjD;EACE,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["/* Grok-style scrollbar - Global styles */\n\n/* Webkit browsers (Chrome, Safari, Edge) */\n*::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n*::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  transition: background 0.2s ease;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background: rgba(237, 137, 54, 0.6); /* Orange on hover */\n}\n\n/* Firefox */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(0, 0, 0, 0.15) transparent;\n}\n\n/* Smooth scrolling for all scrollable elements */\n* {\n  scroll-behavior: smooth;\n}\n\n/* Premium button animations */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
